import React from 'react';
import styles from './index.module.less';
import { FacebookShareButton, TwitterShareButton } from 'react-share';
import copy from 'clipboard-copy';
import { App } from 'antd';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const SharePage = ({ shareUrl }: { shareUrl: string }) => {
  const { message } = App.useApp();

  const { t } = useTranslation('common');
  const twPath = '/images/share/share_fb.webp';

  const copyPath = '/images/share/link.webp';

  const title = `Loving this! 🌟 Can't believe I didn't find this sooner.`;

  const handleCopyAction = async () => {
    try {
      await copy(shareUrl);
      message.success(t('URLCopiedToClipboard'));
    } catch (err) {
      console.error('Unable to copy text to clipboard:', err);
    }
  };

  return (
    <div className={styles.container}>
      <span>{t('share')}</span>
      <FacebookShareButton url={shareUrl}>
        {/* <img src='/images/share/share_fb.webp' /> */}
        <div className={styles.imgItem}>
          <Image
            src="/images/share/facebook.webp"
            alt="Facebook Share"
            loading="lazy"
            width={20}
            height={20}
          />
        </div>
      </FacebookShareButton>

      <TwitterShareButton title={title} url={shareUrl}>
        {/* <img src={twPath} /> */}
        <div className={styles.imgItem}>
          <Image src={twPath} alt="Twitter Share" loading="lazy" width={20} height={20} />
        </div>
      </TwitterShareButton>

      {/* <img src={copyPath} onClick={handleCopyAction} /> */}
      <div className={styles.imgItem}>
        <Image
          src={copyPath}
          alt="Copy"
          loading="lazy"
          width={20}
          height={20}
          onClick={handleCopyAction}
        />
      </div>
    </div>
  );
};

export default SharePage;
